// Non-negotiable disclaimer for every screen that generates a compliance
// document (see .claude/rules/compliance.md). Do not edit or soften the text.
export const COMPLIANCE_DISCLAIMER =
  'Boligflow genererer dette dokument baseret på de oplysninger du har indtastet. Vi tilbyder værktøjer til at understøtte din administration — ikke juridisk rådgivning. Ved tvivl, kontakt en advokat.'

export function ComplianceDisclaimer({ style }: { style?: React.CSSProperties }) {
  return (
    <p style={{ fontSize: 12, color: '#6b7280', lineHeight: 1.5, margin: '16px 0 0', ...style }}>
      {COMPLIANCE_DISCLAIMER}
    </p>
  )
}
